import React from 'react';
import { Collapse } from 'reactstrap';

import { UiKit } from 'components';
import { FeatureContainer } from '../../../../../components';
import { useShippingConfig } from '../../context';
import { FEE_TYPE } from '../../stubs';

export default function Fee({ isDisabled = false }) {
  const { data, errors, isProcessing, onChange } = useShippingConfig();

  const disabled = isProcessing || isDisabled;

  if (data.paidBy === 'MERCHANT') return null;

  return (
    <FeatureContainer
      title="How much should the Customer pay for return shipping?"
      subtitle="Choose whether return shipping costs should be the actual cost of shipping or a fixed amount."
      gap={24}
    >
      <UiKit.Radio.Group
        name="shipping-fee"
        value={data.feeType}
        onChange={value => onChange({ feeType: value })}
        error={errors.feeType}
        disabled={disabled}
        gap={12}
      >
        <UiKit.Radio.Card
          value={FEE_TYPE.FLAT_FEE}
          labelWeight="bold"
          label="Fixed Fee"
          description="Customers pay a fixed amount, you as the Merchant cover any difference."
        >
          <Collapse isOpen={data.feeType === FEE_TYPE.FLAT_FEE}>
            <UiKit.Separator className="my-2" />
            <UiKit.Grid templateColumns="1fr 1fr">
              <UiKit.Input
                label="Fee"
                type="number"
                min={0}
                value={data.feeAmount}
                onChange={value => onChange({ feeAmount: value })}
                error={errors.feeAmount}
                disabled={disabled}
                placeholder="Enter amount"
                icon={<UiKit.Text>$</UiKit.Text>}
              />
            </UiKit.Grid>
          </Collapse>
        </UiKit.Radio.Card>
        <UiKit.Radio.Card
          value={FEE_TYPE.CARRIER_FEE}
          labelWeight="bold"
          label="Actual cost"
          description="Customer pay the actual shipping cost"
        />
      </UiKit.Radio.Group>
    </FeatureContainer>
  );
}
